/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});


/*
 * Checkout externo por produto e variante.
 *
 * Para ativar em outro produto, adicione uma nova entrada usando o handle do
 * produto e os títulos exatos das variantes como aparecem no admin da Shopify.
 * Produtos que não estiverem neste mapa continuam usando o fluxo normal.
 */
(function () {
  'use strict';

  var EXTERNAL_CHECKOUTS = {
  'flexhome-armario-multifuncional-pague-1-leve-2': {
    variants: {
      '2 Pretos': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863093333&store=29678',
      '2 Brancos': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863126101&store=29678',
      '1 Preto e 1 Branco': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863158869&store=29678'
    }
  },

   'multiflex': {
  variants: {
    '3 Andares': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931837239381&store=29678',
    '2 Andares': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931837272149&store=29678'
  }
},

  'swifty-sharp-pv1': {
    variants: {
      'Default Title': 'https://seguro.pay.ventureatacadista.com/api/public/shopify?product=44036075815023&store=10507'
    }
  },

     'limpamax-robo-aspirador': {
  variants: {
    'Preto': 'https://seguro.pay.ventureatacadista.com/api/public/shopify?product=1050754564986&store=10507',
    'Branco': 'https://seguro.pay.ventureatacadista.com/api/public/shopify?product=1050767838135&store=10507'
  }
},

 'kit-com-15-potes-hermeticos-de-vidro-10-copos-de-aruba-de-brinde': {
  variants: {
    'Branco / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931837534293&store=29678',
    'Azul / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931837567061&store=29678',
    'Vermelho / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931837599829&store=29678'
  }
},

 'kit-com-15-potes-hermeticos-de-vidro-10-copos-de-aruba-de-brinde-1': {
  variants: {
    'Branco / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863191637&store=29678',
    'Azul / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863224405&store=29678',
    'Vermelho / (5x) 370 ml + (5x) 435 ml + (5x) 640 ml': 'https://seguro.ventureatacadista.com/api/public/shopify?product=42931863257173&store=29678'
  }
}
};


  function getProductData(button) {
    var scope = button.closest('.product-block-list__item--info') ||
      button.closest('section[data-section-type="product"]');
    var jsonElement = scope && scope.querySelector('script[type="application/json"][data-product-json]');

    if (!jsonElement) {
      var productJsonElements = document.querySelectorAll('script[type="application/json"][data-product-json]');
      if (productJsonElements.length === 1) {
        jsonElement = productJsonElements[0];
      }
    }

    if (!jsonElement) {
      return null;
    }

    try {
      return JSON.parse(jsonElement.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(productData, form) {
    var variantIdField = form.querySelector('[name="id"]');
    var selectedVariantId = variantIdField && variantIdField.value;

    if (!selectedVariantId && productData.selected_variant_id) {
      selectedVariantId = productData.selected_variant_id;
    }

    for (var index = 0; index < productData.product.variants.length; index += 1) {
      if (String(productData.product.variants[index].id) === String(selectedVariantId)) {
        return productData.product.variants[index];
      }
    }

    return null;
  }

  function getExternalCheckoutUrl(button) {
    var form = button.closest('form');
    var productData = form && getProductData(button);

    if (!form || !productData || !productData.product) {
      return null;
    }

    var productConfig = EXTERNAL_CHECKOUTS[productData.product.handle];
    if (!productConfig || !productConfig.variants) {
      return null;
    }

    var selectedVariant = getSelectedVariant(productData, form);
    if (!selectedVariant) {
      return null;
    }

    return productConfig.variants[selectedVariant.title] || null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(
      'button.product-form__add-button.button--primary'
    );
    var floatingButton = event.target.closest && event.target.closest('#clicar');

    // O CTA flutuante mobile chama o botão principal via jQuery. Resolvemos
    // aqui o mesmo botão para aplicar a regra antes do gatilho interno do tema.
    if (!button && floatingButton) {
      button = document.querySelector(
        'section[data-section-type="product"] .product-form__add-button.button--primary'
      );
    }

    // O botão "Adicionar ao carrinho" usa a classe button--primary-add e não
    // entra neste seletor. Assim, somente o "Comprar agora" é redirecionado.
    if (!button || button.disabled) {
      return;
    }

    var externalCheckoutUrl = getExternalCheckoutUrl(button);
    if (!externalCheckoutUrl) {
      return;
    }

    // Captura antes do JavaScript principal do tema, impedindo o add-to-cart
    // AJAX somente para produtos/variantes que possuem URL configurada.
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(externalCheckoutUrl);
  }, true);
})();



/*
 * Cabeçalho sem interação.
 * O bloqueio é aplicado ao contêiner inteiro do header, incluindo logo,
 * navegação, busca, rastreio, carrinho, seletores e barra promocional.
 */
(function () {
  'use strict';

  var HEADER_SELECTOR = 'section[data-section-type="header"], header.header';
  var HEADER_EVENTS = [
    'click',
    'pointerdown',
    'pointerup',
    'mousedown',
    'mouseup',
    'touchstart',
    'touchend',
    'submit',
    'keydown'
  ];

  function isInsideHeader(target) {
    return target && target.closest && target.closest(HEADER_SELECTOR);
  }

  HEADER_EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!isInsideHeader(event.target)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  });

  // Evita que elementos do cabeçalho recebam foco via navegação por teclado
  // ou foco programático, sem alterar o layout ou a aparência.
  document.addEventListener('focusin', function (event) {
    if (!isInsideHeader(event.target)) {
      return;
    }

    if (typeof event.target.blur === 'function') {
      event.target.blur();
    }

    event.stopImmediatePropagation();
  }, true);
})();
